import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {Tabs,TabList,TabPanel,Tab} from 'react-tabs'
import 'react-tabs/style/react-tabs.css';
import Customers from './Customers';
import Recent from './Recent';
import Employees from './Employees';
import Settings from './Settings';
import UserContext from '../../context/UserContext';
const Admin = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const path = window.location.pathname;
  const nav = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const {apiURL} = useContext(UserContext)
  useEffect(() => {


    const getUsers = async () => {
      try {
        const res = await axios.get(`${apiURL}/users/users/all`);
        setCustomers(res.data.message);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    getUsers();
  }, []);

  
  return (
    <div className='w-full py-[25px] px-[5%]'>
   <Tabs>
    <TabList className='flex'>
      <Tab>Recent Uploads</Tab>
      <Tab>Customers</Tab>
       <Tab>Employees</Tab>
        <Tab>Site Settings</Tab>
    </TabList>

    <TabPanel>
      <Recent />
    </TabPanel>



    <TabPanel>
     <Customers />
    </TabPanel>
    
    <TabPanel>
     <Employees />
    </TabPanel>

     <TabPanel>
     <Settings />
    </TabPanel>
  </Tabs>


    
    </div>
  );
};

export default Admin;